import React from 'react';
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { useAppContext } from "./AppContext";
import { negativeRed, positiveGreen } from "../util/style";

interface UpDownArrowProps {
  number: number;
  color?: string | null;
}

const UpDownArrow: React.FC<UpDownArrowProps> = ({ number, color = null }) => {
  const { getFont } = useAppContext() || {};
  return (
    <>
      {isNaN(number) || number === 0 ? (
        <ArrowDropUpIcon
          style={{
            fontSize: getFont?.(10),
            color: "transparent",
            transform: "scale(2)",
          }}
        />
      ) : number < 0 ? (
        <ArrowDropDownIcon
          style={{
            fontSize: getFont?.(10),
            color: color ? color : negativeRed,
            transform: "scale(2)",
          }}
        />
      ) : (
        <ArrowDropUpIcon
          style={{
            fontSize: getFont?.(10),
            color: color ? color : positiveGreen,
            transform: "scale(2)",
          }}
        />
      )}
    </>
  );
};

export default UpDownArrow;
